<template>
    <Intro />
    <Benefit />
    <Oss />
    <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/tpa/TPAIntro.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";
import Benefit from "@/components/tpa/TPABenefit.vue"
import Oss from "@/components/tpa/TPAOneStopService.vue"

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>